import { useQuery } from 'react-query'

import { getCountries } from '../../apis/public.api';

export interface ICountry {
  country: string;
  idCountry: number;
  nacionalidad: string;
}

function useCountries() {
  return useQuery('countries', async () => {
    const countries = await getCountries()

    return countries;
  })
}

export { useCountries }
